<div class="max-reached" *ngIf="isMaxReached()">
    {{ maxSelectedItemMessage }}
</div>
<div class="autocomplete-api">
    <input class="autocomplete-api-input" matInput [matAutocomplete]="auto" [formControl]="searchValuesCtrl" />
    <div class="static-images">
        <img class="icon" src="assets/images/common/search.svg" alt="search" />
    </div>
</div>
<div *ngIf="isLoading$ | async" class="is-loading">Loading...</div>
<mat-autocomplete #auto="matAutocomplete" [displayWith]="displayWith" panelWidth="auto">
    <ng-container *ngIf="(isLoading$ | async) === false">
        <mat-option
            *ngFor="let value of filteredValues"
            [value]="value"
            class="mat-option"
            (click)="optionClicked($event, value)"
            [disabled]="isOptionDisabled(value)">
            <mat-checkbox color="primary" [checked]="selectedIds.has(value.id)" [disabled]="isOptionDisabled(value)"> </mat-checkbox>
            <span>{{ value.displayName }}</span>
        </mat-option>
    </ng-container>
</mat-autocomplete>
<div *ngIf="allValues$.value.length > 0">
    <div
        *ngFor="let value of allValues$ | async"
        (click)="optionClicked($event, value)"
        [ngClass]="{
            'autocomplete-api-option-selected': selectedIds.has(value.id),
            'autocomplete-api-option-disabled': value.disabled || isOptionDisabled(value),
        }">
        <mat-checkbox
            color="primary"
            [checked]="selectedIds.has(value.id)"
            (click)="$event.stopPropagation()"
            (change)="toggleSelection(value)"
            [disabled]="isOptionDisabled(value)">
            {{ value.displayName }}
        </mat-checkbox>
    </div>
</div>
